import { extractBranchName, sanitizeDbName } from '@thecompaniesapi/string-helpers'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  if (process.env.COOLIFY_BRANCH) {
    const coolifyBranch = extractBranchName(process.env.COOLIFY_BRANCH || '')

    if (coolifyBranch && coolifyBranch !== 'dev') {
      const branchName = sanitizeDbName(coolifyBranch)

      runtimeConfig.public.apis.public = `https://${branchName}-api.thecompaniesapi.dev`
      runtimeConfig.public.apis.private = `https://${branchName}-api.thecompaniesapi.dev`
      runtimeConfig.public.apis.socket = `https://${branchName}-api.thecompaniesapi.dev`
    }

    if (coolifyBranch === 'dev') {
      runtimeConfig.public.apis.public = 'https://api.thecompaniesapi.dev'
      runtimeConfig.public.apis.private = 'https://api.thecompaniesapi.dev'
      runtimeConfig.public.apis.socket = 'https://api.thecompaniesapi.dev'
    }
  }
})
